import React from 'react';
import './PatternIcon.css';
import { getPatternById } from '../config/patterns';

const PatternIcon = ({ patternId, size = 'normal' }) => {
  const pattern = getPatternById(patternId);
  
  if (!pattern) {
    return <div className="pattern-icon-container">Pattern not found</div>;
  }

  // Get the base pattern positions from the pattern definition
  const getBasePattern = () => {
    switch (patternId) {
      case 'tic':
        return [[0, 0], [0, 1], [0, 2]];
      case 'skinny':
        return [[0, 0], [0, 1], [0, 2], [0, 3]];
      case 'el':
        return [[0, 0], [1, 0], [1, 1]];
      case 'boxy':
        return [[0, 0], [0, 1], [1, 0], [1, 1]];
      case 'elly':
        return [[0, 0], [1, 0], [2, 0], [2, 1]];
      case 'knobby':
        return [[0, -1], [0, 0], [0, 1], [1, 0]];
      case 'tippy':
        return [[0, 0], [0, 1], [1, 1], [1, 2]];
      case 'snaky':
        return [[0, 0], [0, 1], [1, 1], [1, 2], [1, 3], [1, 4]];
      case 'aspy':
        return [[0, 0], [0, 1], [1, 1], [1, 2], [1, 3]];
      case 'cross':
        return [[0, 1], [1, 0], [1, 1], [1, 2], [2, 1]];
      case 'tee':
        return [[0, 0], [0, 1], [0, 2], [1, 1], [2, 1]];
      case 'f':
        return [[0, 1], [0, 2], [1, 1], [2, 0], [2, 1]];
      case 'stair':
        return [[0, 0], [1, 0], [1, 1], [2, 1], [2, 2]];
      case 'p':
        return [[0, 1], [0, 2], [1, 0], [1, 1], [2, 1]];
      case 'l':
        return [[0, 0], [1, 0], [1, 1], [1, 2], [1, 3]];
      case 'y':
        return [[0, 1], [1, 0], [1, 1], [1, 2], [1, 3]];
      case 'u':
        return [[0, 0], [0, 2], [1, 0], [1, 1], [1, 2]];
      case 'c':
        return [[0, 0], [0, 1], [0, 2], [0, 3], [1, 0], [1, 3]];
      case 's':
        return [[0, 2], [0, 3], [0, 4], [1, 0], [1, 1], [1, 2]];
      case 'i':
        return [[0, 0], [0, 1], [0, 2], [0, 3], [0, 4]];
      default:
        return [[0, 0]];
    }
  };

  const basePattern = getBasePattern();
  
  // Calculate grid dimensions based on pattern bounds
  let minRow = 0, maxRow = 0, minCol = 0, maxCol = 0;
  for (const [dr, dc] of basePattern) {
    minRow = Math.min(minRow, dr);
    maxRow = Math.max(maxRow, dr);
    minCol = Math.min(minCol, dc);
    maxCol = Math.max(maxCol, dc);
  }
  
  const gridRows = maxRow - minRow + 1;
  const gridCols = maxCol - minCol + 1;
  
  // Create a grid representation
  const grid = Array(gridRows).fill(null).map(() => Array(gridCols).fill(false));
  
  // Mark pattern positions
  for (const [dr, dc] of basePattern) {
    const row = dr - minRow;
    const col = dc - minCol;
    if (row >= 0 && row < gridRows && col >= 0 && col < gridCols) {
      grid[row][col] = true;
    }
  }

  // Determine cell size based on size prop
  // Make micro larger for phone UI; ~50% bigger than previous
  const cellSize = size === 'small' ? 8 : size === 'tiny' ? 6 : size === 'micro' ? 18 : 20;
  const gap = size === 'small' ? 1 : size === 'tiny' ? 1 : size === 'micro' ? 3 : 2;

  return (
    <div className="pattern-icon-container">
      <div 
        className="pattern-grid dynamic-pattern"
        style={{
          gridTemplateColumns: `repeat(${gridCols}, 1fr)`,
          gridTemplateRows: `repeat(${gridRows}, 1fr)`,
          width: `${gridCols * cellSize + (gridCols - 1) * gap}px`,
          height: `${gridRows * cellSize + (gridRows - 1) * gap}px`,
          gap: `${gap}px`
        }}
      >
        {grid.flat().map((isFilled, index) => (
          <div 
            key={index} 
            className={`pattern-cell ${isFilled ? 'filled' : ''}`}
            style={{
              width: `${cellSize}px`,
              height: `${cellSize}px`,
              borderWidth: size === 'small' ? '1px' : size === 'tiny' ? '1px' : size === 'micro' ? '1px' : '2px',
              borderRadius: size === 'small' ? '2px' : size === 'tiny' ? '1px' : size === 'micro' ? '0px' : '4px'
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default PatternIcon;
